import clsx from 'clsx';

import { agreements } from './agreements';
import { AgreementView } from './agreement-view';

import styles from './agreements-screen.module.scss';

export const AgreementPage = ({ agreement }: { agreement: keyof typeof agreements }) => (
  <div className={styles.agreementsScreen}>
    <div className={clsx(styles.card, styles.wide)}>
      <div className={styles.content}>
        <AgreementView agreement={agreements[agreement]} />
      </div>
    </div>
  </div>
);
